export default __webpack_public_path__ + "static/media/bg-8.1f6d4305.jpg";